<template>
  <v-main class="admin-layout">
    <slot></slot>
  </v-main>
</template>

<script>
export default {
  name: 'AdminLayout'
}
</script>
